import { render, staticRenderFns } from "./Index--Banners.vue?vue&type=template&id=89b80b86&scoped=true&"
import script from "./Index--Banners.vue?vue&type=script&lang=js&"
export * from "./Index--Banners.vue?vue&type=script&lang=js&"
import style0 from "./Index--Banners.vue?vue&type=style&index=0&id=89b80b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b80b86",
  null
  
)

export default component.exports